// ---- components/About.js ----
export function About() {
  return (
    <section id="about" className="px-6 py-16 max-w-6xl mx-auto">
      <h2 className="text-3xl font-bold text-center mb-1">
        Warehouse & Delivery Operations Made Smarter
      </h2>
      <p className="text-lg text-gray-700 dark:text-gray-300">
        Ethos Smart Warehouse & Delivery empowers your logistics team with comprehensive tools to manage 
        inventory across multiple warehouses, process supplier receipts and customer returns, optimize 
        storage with bin-level precision, and streamline delivery operations with real-time tracking. 
        With barcode scanning, automated trip planning, and mobile field applications, our solution 
        helps your business reduce errors, improve inventory accuracy, and enhance delivery efficiency. 
        Designed for modern supply chains, it transforms your warehouse and distribution operations 
        from fragmented processes to integrated, intelligent workflows.
      </p>
      <div className="mt-6 grid grid-cols-1 md:grid-cols-2 gap-3 text-sm">
        <div className="flex items-center">
          <span className="text-green-500 mr-2">✓</span>
          Multi-warehouse with location & bin management
        </div>
        <div className="flex items-center">
          <span className="text-green-500 mr-2">✓</span>
          Barcode scanning for items and warehouse bins
        </div>
        <div className="flex items-center">
          <span className="text-green-500 mr-2">✓</span>
          Automated stock receipt & returns processing
        </div>
        <div className="flex items-center">
          <span className="text-green-500 mr-2">✓</span>
          Real-time delivery tracking & field operations
        </div>
        <div className="flex items-center">
          <span className="text-green-500 mr-2">✓</span>
          Trip planning, pick lists & cage management
        </div>
        <div className="flex items-center">
          <span className="text-green-500 mr-2">✓</span>
          Comprehensive reporting & statistical insights
        </div>
      </div>
    </section>
  );
}